import React from "react";

const LocationPrompt = ({
  user,
  userLocation,
  handleClick,
  handleRequest,
  className,
}) => {
  return (
    <>
      {userLocation?.isDefault || user?.location?.isDefault ? (
        <span className={className} onClick={handleRequest}>
          <span>No event fround for</span>
          <strong>{userLocation?.country || user?.location?.country}</strong>
          <span>. Request events happening near by you</span>{" "}
          <strong>Click Here</strong>
        </span>
      ) : (
        <span className={className} onClick={handleClick}>
          <span>You are viewing events for</span>
          <strong>{userLocation?.city || user?.location?.city}</strong>
          <span>. To view events happening near by you</span>{" "}
          <strong>Click Here</strong>
        </span>
      )}
    </>
  );
};

export default LocationPrompt;
